import { useEffect, useState } from 'react';
import { asset } from '../assets';
import { supabaseClient } from '../supabase';
import { useLanguage } from './LanguageProvider';

const fallbackOffers = [
  { id: 'fallback-1', image_url: asset('assets/offer1.png'), title_en: 'Plus Package', title_ar: 'باقة بلس', price: 150 },
  { id: 'fallback-2', image_url: asset('assets/offer2.png'), title_en: 'Plus Package', title_ar: 'باقة بلس', price: 150 },
  { id: 'fallback-3', image_url: asset('assets/offer3.png'), title_en: 'Plus Package', title_ar: 'باقة بلس', price: 150 },
];

export function OffersSection() {
  const { language, t } = useLanguage();
  const [offers, setOffers] = useState(fallbackOffers);

  useEffect(() => {
    let active = true;

    async function loadOffers() {
      const { data, error } = await supabaseClient
        .from('offers')
        .select('id, image_url, title_en, title_ar, price')
        .eq('is_active', true)
        .order('sort_order', { ascending: true })
        .limit(3);

      if (active && !error && data?.length) setOffers(data);
    }

    loadOffers();
    return () => {
      active = false;
    };
  }, []);

  const requestBundle = () => {
    window.location.hash = 'quote';
  };

  return (
    <section className="section_2" id="offers">
      <h2>{t('Offers', 'العروض')}</h2>
      <div className="sec2_cards_holder">
        {offers.map((offer) => {
          const title = language === 'ar' ? offer.title_ar || offer.title_en : offer.title_en;

          return (
            <article className="sec2_card" key={offer.id}>
              <div className="card-top">
                <img src={offer.image_url} alt={title || t('Printing offer', 'عرض طباعة')} className="card-image" />
              </div>
              <div className="card-bottom">
                <h3 className="card-title">{title}</h3>
                <div className="card-price-row">
                  <div className="card-price-label">{t('Only for', 'فقط مقابل')}</div>
                  <div className="price-badge">
                    <span className="price-amount">{offer.price}</span>
                    <span className="price-currency">{t('EGP', 'جنيه')}</span>
                  </div>
                </div>
                <button className="card-btn" onClick={requestBundle} type="button">
                  <span>{t('Request this bundle', 'اطلب هذه الباقة')}</span>
                  <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" />
                </button>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
